import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function clientether() {
  return (
    <section className="client_ether p-100 text_white back_dark">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>The Client</h2>
            <p>
              Elementeum Games is a dedicated sponsor of blockchain based games
              that’s widely known for advocating contemporary trends that
              illustrate the potential for exponential growth. And that’s why
              they wanted to provide a platform for people to utilize the
              blockchain to earn money, own digital assets (through Non-Fungible
              Tokens (NFT’s), while having fun within the interactive, gamified
              environment.
            </p>
            <div className="client_coin_img">
              <StaticImage
                src="../../../images/case-studies/ether/coin.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={179}
                height={183}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1 "
          >
            <div className="client_ether_img">
              <StaticImage
                src="../../../images/case-studies/ether/client_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1079}
                height={657}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default clientether;
